/* eslint-disable */

import { AddOn } from './AddOn';
import { AddOnType } from '../FbbEnum';

export class AddOnWiFi7Vas extends AddOn {

	constructor() {
		super();
		this.key = 'AddOnWiFi7Vas';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = '';
		this.boxNameZh = '';
		this.boxAmount = 0;
		this.hasRedCounter = false;
		this.type = AddOnType.SINGLE;
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}
}
